<template>

    <XTable
      :model="model"
      ref="calender"
      :options="{ placeholder:'Search calender',noContent: 'No calender',is_load_req: false }"
      @refresh="refresh"
    >
      <span slot="start" slot-scope="text,record">{{ setDateFormat(text.record.start) }}</span>
      <span slot="end" slot-scope="text,record">{{ setDateFormat(text.record.end) }}</span>
    </XTable>

</template>

<script>

import * as TblColCalender from "./calenderTbl";
import XTable from "../../components/x-table/XTable";
import mixin from "@/views/mixin/mixin";
import axios from "@/axios"

export default {
  name: "ListCalenderMatter",
  mixins:[mixin],
  components:{
    XTable
  },
  data(){
    return{
      model: null
    }
  },
  methods:{
    refresh(){
      this.$refs.calender.query.query = [{ field:'matter__id',value: matter_id , condition: '=' }]
    },
    async getEvents () {
      try {
        const matter_id = this.$store.state.dashboard_contact_id || this.$route.params.id
        const { data } = await axios.post('/calendar/event/query/',{ query: [{ field:'matter__id',value: matter_id , condition: '=' }] })
        console.log(data,'daaaaaaaaaaaaaaaaaa')
        this.$refs.calender.data = data.rows
      } catch (e) {
        console.log(e)
      }
    }
  },
  created() {
    this.model = TblColCalender.default
    this.getEvents()
  }
}
</script>

<style scoped>

</style>
